<div mat-dialog-content>
    <div
        class="slider"
        *ngrxLet="{ photoUrls: photoUrls$, currentIndex: currentIndex$, arePhotoUrlsProcessing: arePhotoUrlsProcessing$ } as vm"
    >
        <button
            class="button-icon left-arrow"
            type="button"
            (click)="previousPhoto()"
            *ngIf="vm.photoUrls.length > 1"
            [attr.aria-label]="'dtmUi.carousel.previousSlideAriaLabel' | transloco"
        >
            <dtm-ui-icon name="arrow-left" />
        </button>
        <dtm-ui-loader-container [isShown]="vm.arePhotoUrlsProcessing">
            <ul class="slides">
                <ng-container *ngFor="let photoUrl of vm.photoUrls; let index = index">
                    <li class="slide" [class.hide-left]="index < vm.currentIndex" [class.hide-right]="index > vm.currentIndex">
                        <img [dtmUiImgSecuredSrc]="photoUrl" (loadingChange)="setPhotoUrlProcessing($event, photoUrl)" alt="" />
                    </li>
                </ng-container>
            </ul>
        </dtm-ui-loader-container>
        <button
            class="button-icon right-arrow"
            type="button"
            (click)="nextPhoto()"
            *ngIf="vm.photoUrls.length > 1"
            [attr.aria-label]="'dtmUi.carousel.nextSlideAriaLabel' | transloco"
        >
            <dtm-ui-icon name="arrow-right" />
        </button>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button type="button" class="button-primary" [mat-dialog-close]="true">
        {{ "dtmMapCesium.dronePointDetails.photoModalCloseButtonLabel" | transloco }}
    </button>
</div>
